<template>
  <div class="home">
    <div class="horizontal-layout horizontal-menu content-left-sidebar chat-application  menu-expanded pace-done">
      <div class="app-content content pl-1 pt-1 pr-1">
        <div class="row">
          <div class="col-xl-8 col-12">
            <VuePerfectScrollbar class="scroll-area sidebar-left sidebar-fixed ps-theme-dark">
              <div class="sidebar">
                <div class="sidebar-content d-none d-lg-block">
                  <div id="users-list" class="list-group position-relative">
                    <div class="media-list p-1">
                      <div id="accordionWrap3" role="tablist" aria-multiselectable="true">
                        <div class="card">
                          <div id="heading31" class="card-header bg-white border-bottom">
                            <a data-toggle="collapse" data-parent="#accordionWrap3" href="#accordion31" aria-expanded="false" aria-controls="accordion31" class="card-title text-dark collapsed">
                              <i class="ft-message-circle mr-2"></i>{{$t('discussions_title')}}
                            </a>
                          </div>
                          <div class="room-block" v-if="AllRooms.running.length">
                            <div class="card-header border-bottom">
                              <b-link v-b-toggle.runningRooms data-parent="#accordionWrap3" variant="primary" href="#" class="card-title text-dark collapsed w-100 d-block">
                                {{$t('running_title')}}
                                <span class="badge badge-pill badge-default badge-success badge-default badge-glow pull-right">{{AllRooms.running.length}}</span>
                              </b-link>
                            </div>
                            <b-collapse id="runningRooms" accordion="rooms" class="card-collapse" aria-expanded="true">
                              <a v-bind:class="{'media border-bottom' : index == AllRooms.running.length - 1 , 'media border-0' : index != AllRooms.running.length - 1}" v-for="(room, index) in AllRooms.running" :key="index + 'running'" v-on:click="setCurrentRoom(room.uuid)">
                                <div class="media-left pr-1">
                                  <span class="avatar avatar-md avatar-online">
                                    <img class="media-object rounded-circle" src="@/app-assets/images/user-guest.png" alt="Generic placeholder image">
                                    <i></i>
                                  </span>
                                </div>
                                <div class="media-body w-100">
                                  <h6 class="list-group-item-heading">
                                    {{room.infos.name}}
                                    <span class="font-small-2 float-right info" v-if="room.last_running">{{updateTime(room.last_running)}}</span>
                                  </h6>
                                  <p class="list-group-item-text text-muted mb-0">
                                    <span class="float-right primary">
                                      <span class="badge badge-pill badge-default badge-danger badge-default badge-glow" v-if="room.unread_msg">{{room.unread_msg}}</span>
                                    </span>
                                  </p>
                                </div>
                              </a>
                            </b-collapse>
                          </div>
                          <div class="room-block" v-if="AllRooms.late.length">
                            <div class="card-header border-bottom">
                              <b-link v-b-toggle.lateRooms variant="primary" href="#" class="card-title text-dark collapsed w-100 d-block">
                                {{$t('late_title')}}
                                <span class="badge badge-pill badge-default badge-danger badge-default badge-glow pull-right">{{AllRooms.late.length}}</span>
                              </b-link>
                            </div>
                            <b-collapse id="lateRooms" accordion="rooms" class="card-collapse" aria-expanded="true">
                              <a href="#" v-bind:class="{'media border-bottom' : index == AllRooms.late.length - 1 , 'media border-0' : index != AllRooms.late.length - 1}" v-for="(room, index) in AllRooms.late" :key="index + 'late'" v-on:click="setCurrentRoom(room.uuid)">
                                <div class="media-left pr-1">
                                  <span class="avatar avatar-md avatar-online">
                                    <img class="media-object rounded-circle" src="@/app-assets/images/user-guest.png" alt="Generic placeholder image">
                                    <i></i>
                                  </span>
                                </div>
                                <div class="media-body w-100">
                                  <h6 class="list-group-item-heading">
                                    {{room.infos.name}}
                                    <span class="font-small-2 float-right info" v-if="room.last_running">{{updateTime(room.last_running)}}</span>
                                  </h6>
                                  <p class="list-group-item-text text-muted mb-0">
                                    <span class="float-right primary">
                                      <span class="badge badge-pill badge-default badge-danger badge-default badge-glow" v-if="room.unread_msg">{{room.unread_msg}}</span>
                                    </span>
                                  </p>
                                </div>
                              </a>
                            </b-collapse>
                          </div>
                          <div class="room-block" v-if="getTotalLength(AllRooms.waiting)">
                            <div class="card-header border-bottom">
                              <b-link v-b-toggle.waitingRooms variant="primary" href="#" class="card-title text-dark collapsed w-100 d-block">
                                {{$t('waiting_title')}}
                                <span class="badge badge-pill badge-default badge-info badge-default badge-glow pull-right">{{getTotalLength(AllRooms.waiting)}}</span>
                              </b-link>
                            </div>
                            <b-collapse id="waitingRooms" accordion="rooms" class="card-collapse" aria-expanded="true">
                              <div v-for="(category, key, index) in AllRooms.waiting" :key="category + index">
                                <a href="#" class="media border-bottom">
                                  <div class="media-body w-100">
                                    <span class="text-info">
                                      <strong>{{key}}</strong>
                                    </span>
                                  </div>
                                </a>
                                <a href="#" v-bind:class="{'media border-bottom' : index == category.length - 1 , 'media border-0' : index != category.length - 1}" v-for="(room, index) in category" :key="index + 'waiting'" v-on:click="setCurrentRoom(room.uuid)">
                                  <div class="media-left pr-1">
                                    <span class="avatar avatar-md avatar-online">
                                      <img class="media-object rounded-circle" src="@/app-assets/images/user-guest.png" alt="Generic placeholder image">
                                      <i></i>
                                    </span>
                                  </div>
                                  <div class="media-body w-100">
                                    <h6 class="list-group-item-heading">
                                      {{room.infos.name}}
                                      <span class="font-small-2 float-right info" v-if="room.last_waiting">{{updateTime(room.last_waiting)}}</span>
                                      <!-- <span class="font-small-2 float-right info" v-else>{{updateTime(room.created)}}</span> -->
                                    </h6>
                                    <p class="list-group-item-text text-muted mb-0" v-if="room.status == 'transferred'">via transfert</p>
                                  </div>
                                </a>
                              </div>
                            </b-collapse>
                          </div>
                          <div class="room-block" v-if="AllRooms.closed.length">
                            <div class="card-header border-bottom">
                              <b-link v-b-toggle.closedRooms variant="primary" href="#" class="card-title text-dark collapsed w-100 d-block">
                                {{$t('closed_title')}}
                                <span class="badge badge-pill badge-default badge-warning badge-default badge-glow pull-right">{{AllRooms.closed.length}}</span>
                              </b-link>
                            </div>
                            <b-collapse id="closedRooms" accordion="rooms" class="card-collapse" aria-expanded="true">
                              <a href="#" v-bind:class="{'media border-bottom' : index == AllRooms.closed.length - 1 , 'media border-0' : index != AllRooms.closed.length - 1}" v-for="(room, index) in AllRooms.closed" :key="index + 'closed'" v-on:click="setCurrentRoom(room.uuid)">
                                <div class="media-left pr-1">
                                  <span class="avatar avatar-md avatar-online">
                                    <img class="media-object rounded-circle" src="@/app-assets/images/user-guest.png" alt="Generic placeholder image">
                                    <i></i>
                                  </span>
                                </div>
                                <div class="media-body w-100">
                                  <h6 class="list-group-item-heading">
                                    {{room.infos.name}}
                                    <span class="font-small-2 float-right info" v-if="room.last_running">{{getClosedRoomTime(room)}}</span>
                                  </h6>
                                </div>
                              </a>
                            </b-collapse>
                          </div>
                        </div>
                        <div class="card" v-if="CurrentRoom.status == 'running' || CurrentRoom.status == 'late'">
                          <div id="heading31" class="card-header bg-white border-bottom">
                              <a data-toggle="collapse" data-parent="#accordionWrap3" href="#accordion31" aria-expanded="false" aria-controls="accordion31" class="card-title text-dark collapsed">
                              <i class="ft-phone-forwarded mr-2"></i>{{$t('channels_title')}}</a>
                          </div>
                          <a href="#" class="media border-0">
                              <div class="media-body w-100">
                                <h6 class="list-group-item-heading align-items-center"><button type="button" class="btn btn-info btn-sm round" v-on:click="getZencalls">Appels Zen</button>
                                </h6>
                              </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VuePerfectScrollbar>
            <div class="content-right">
              <div class="content-wrapper">
                  <div v-bind:class="{'content-body normal-order': CurrentRoom.status == 'waiting' || CurrentRoom.status == 'transferred' || historyShown , 'content-body': !(CurrentRoom.status == 'waiting' || CurrentRoom.status == 'transferred' || historyShown) }">
                    <section v-bind:class="{'card m-1 chat-app-window disabled' : CurrentRoom.status == 'closed' , 'card m-1 chat-app-window' : CurrentRoom.status != 'closed'}" id="chat-app-window">
                      <div class="history-chat-block">
                        <div class="alert bg-danger alert-dismissible mb-2 text-left history-alert" role="alert" v-if="historyShown">
                          <button type="button" class="btn btn-dark round btn-min-width mr-1 btn-sm" v-on:click="getDefaultMessages()">Retour à la discussion</button><span>Historique du {{this.currentHistory | formatLongDatetime}}</span>
                        </div>
                      </div>
                      <div class="chats">
                          <div class="m-5" v-if="(CurrentRoom.status == 'waiting' || CurrentRoom.status == 'transferred') && !historyShown">
                            <h2>{{$t('conversation_title')}}</h2>
                            <small class="text-info"> Compétence
                            <strong>{{getSkillName(CurrentRoom.skill)}}</strong>
                            </small>
                            <p class="mt-2">Souhaitez-vous prendre en charge cette nouvelle conversation ?</p>
                            <div class="text-center">
                                <button type="button" class="btn btn-outline-dark  round mr-1" data-dismiss="modal">Non, merci !</button>
                                <button type="button" class="btn btn-info  round" data-dismiss="modal" v-on:click="joinRoom(CurrentRoom.uuid)">Avec plaisir 😊</button>
                            </div>
                          </div>
                          <div v-if="!CurrentRoomID">
                            <hr class="m-5">
                            <div class="m-5">
                              <h2>Merci de sélectionner une conversation</h2>
                            </div>
                            <hr class="m-5">
                          </div>
                          <div class="main-chat">
                            <loader v-if="PendingRequest.get_messages"></loader>
                            <div :class="{'main-chat-inner loading-state': PendingRequest.get_messages, 'main-chat-inner': !PendingRequest.get_messages}">
                              <div v-bind:class="{'chat chat-left' : message.kind == 'guest_msg' , 'chat' : message.kind == 'agent_msg'}" v-for="(message, index) in Messages" :key="index">
                                <div class="chat-avatar">
                                    <a class="avatar" data-toggle="tooltip" href="#" data-placement="right" v-if="message.agent_avatar">
                                      <img :src="message.agent_avatar" alt="avatar">
                                    </a>
                                    <a class="avatar" data-toggle="tooltip" href="#" data-placement="right" v-else>
                                      <img src="@/app-assets/images/user-guest.png" alt="avatar">
                                    </a>
                                </div>
                                <div class="chat-body">
                                    <div class="chat-content">
                                      <div class="d-block clearfix">
                                      <span v-bind:class="{'font-small-2 float-left text-left info text-muted w-100' : message.kind == 'guest_msg',
                                       'font-small-2 float-left text-right text-white text-muted w-100' : (message.kind == 'agent_msg') || (message.kind == 'bot_msg')}">{{message.created | formatTime}}</span>
                                      </div>
                                      <div v-if="message.rich_content == null">
                                        <p>{{message.content}}</p>
                                      </div>
                                      <div v-for="(inner, innerIndex) in message.rich_content" :key="innerIndex + 'inner'" v-if="message.rich_content !== null">
                                        <div v-if="inner.kind == 'timeslots'">
                                          <p>{{ inner.title }}</p>
                                          <ul v-for="(timeslot, tsIndex) in inner.timeslots" :key="tsIndex" >
                                            <li>{{ timeslot.label }}</li>
                                          </ul>
                                        </div>
                                        <div v-if="inner.kind == 'timeslot_choice'">
                                          <p>{{ inner.timeslot.label }}</p>
                                        </div>
                                        <div v-if="inner.kind == 'file'">
                                          <a :href="inner.file.url" target="_blank" :class="{'text-white' : (message.kind == 'agent_msg') || (message.kind == 'bot_msg')}" >
                                            <u>{{ inner.file.name }}</u>
                                          </a>
                                        </div>
                                        <div v-if="inner.kind == 'url'">
                                          <a :href="inner.url" target="_blank" :class="{'text-white' : (message.kind == 'agent_msg') || (message.kind == 'bot_msg')}" ><u>{{inner.txt}}</u></a>
                                        </div>
                                        <div v-if="inner.kind == 'payment'">
                                          Paiement pour {{inner.title}} (
                                          {{inner.total.amount|currency}})
                                        </div>
                                        <div v-if="inner.kind == 'payment_result'">
                                          Paiement réussi :)
                                        </div>
                                        <div v-if="inner.kind == 'authentication'">
                                          Demande d'authentification
                                        </div>
                                        <div v-if="inner.kind == 'authentication_result'">
                                            Authentification
                                            <span v-if="inner.status === 'success'">réussie :)<br>
                                              &lt;TOKEN {{ inner.token }}&gt;
                                            </span>
                                            <span v-if="inner.status !== 'success'">échouée :(</span>
                                        </div>
                                        <p v-if="inner.kind == 'txt' && !isObject(inner.txt)">{{inner.txt}}</p>
                                        <div class="media align-items-center mb-2" v-if="inner.kind == 'txt' && inner.txt.kind == 'choosed'">
                                          <a class="media-left" v-bind:href="inner.txt.item.img" style="max-width: 125px;" target="_blank">
                                            <img v-bind:src="inner.txt.item.img" alt="..." class="img-thumbnail">
                                          </a>
                                          <div class="media-body">
                                            <p class="text-left ml-2">
                                            <b>{{inner.txt.item.label}}</b><br>
                                            {{inner.txt.item.desc}}
                                            </p>
                                          </div>
                                        </div>
                                        <div class="media align-items-center mb-2" v-if="inner.kind == 'choice' || inner.kind == 'choosed'">
                                          <a class="media-left" v-bind:href="inner.item.img" style="max-width: 125px;" target="_blank" v-if="inner.item.img">
                                            <img v-bind:src="inner.item.img" alt="..." class="img-thumbnail">
                                          </a>
                                          <div class="media-body">
                                            <p :class="{'text-left ml-2': inner.item.img, 'mt-1': !inner.item.img}">
                                            <b>{{inner.item.label}}</b><br>
                                            {{inner.item.desc}}
                                            </p>
                                          </div>
                                        </div>
                                        <div class="media align-items-center mb-2" v-if="inner.kind == 'item'">
                                          <a class="media-left" v-bind:href="inner.item.img" style="max-width: 125px;" target="_blank">
                                            <img v-bind:src="inner.item.img" alt="..." class="img-thumbnail">
                                          </a>
                                          <div class="media-body">
                                            <p class="text-left ml-2">
                                            <b>{{inner.item.label}}</b><br>
                                            {{inner.item.desc}}
                                            </p>
                                          </div>
                                        </div>
                                        <div class="mapouter mb-2" v-if="inner.kind == 'location'">
                                          <GmapMap
                                            :center="{lat: inner.location.position.lat, lng: inner.location.position.lng}"
                                            :zoom="12"
                                            style="width:300px;  height: 300px;"
                                          >
                                            <GmapMarker
                                              :key="innerIndex"
                                              :position="google && new google.maps.LatLng(inner.location.position.lat, inner.location.position.lng)"
                                            />
                                          </GmapMap>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="send-items-block" v-if="dragToggle">
                            <draggable :options="{group:'products'}" v-model="draggedItems" v-if="draggedItems">
                              <div class="media align-items-center" v-for="(item, index) in draggedItems" :key="index + 'dragged'">
                                <a class="media-left mr-2" href="#">
                                  <div class="img-after">
                                    <img v-bind:src="item.img" alt="..." class="img-thumbnail">
                                  </div>
                                </a>
                                <div class="media-body text-left">
                                  {{item.desc}}
                                </div>
                              </div>
                              <div class="drop-section-description" slot="footer">
                                <i class="ft-file-plus"></i>
                                <p>Faites glisser et déposez les éléments ici</p>
                              </div>
                            </draggable>
                          </div>
                      </div>
                    </section>
                    <section v-bind:class="{'card m-1 bg-info chat-app-form active' : ((CurrentRoom.status == 'running' || CurrentRoom.status == 'late') &&  historyShown == false), 'card m-1 bg-info chat-app-form' : ((CurrentRoom.status != 'running' || CurrentRoom.status != 'late') ||  historyShown == true) }">
                        <form class="chat-app-input" @submit.prevent="sendMessage" autocomplete="off">
                          <div class="row pl-1 pr-1 w-100">
                            <fieldset class="form-group position-relative has-icon-left col-8 m-0">
                                <div class="emoticon-block">
                                  <picker id="emoji-picker" title="Pick your emoji…" emoji="point_up"  :style="{ position: 'absolute', bottom: '10px', left: '0' }" :showPreview="false" v-show="showEmojiPicker" @select="addEmoji"/>
                                  <div class="form-control-position" v-on:click="toggleEmojiPicker" id="emoji-trigger">
                                    <i class="icon-emoticon-smile"></i>
                                  </div>
                                </div>
                                <textarea type="text" class="form-control chat-input" id="chat-input" placeholder="Tapez votre message ..." @input="setCurrentMessage" @keydown.enter="sendMessage" :value="CurrentMessage.content" @focus="checkPause"></textarea>
                            </fieldset>
                            <fieldset class="form-group position-relative has-icon-left m-0 col-4">
                                <div class="btn-group dropup btn-plus mb-1">
                                    <b-dropdown menu-class="no-transition arrow" no-caret variant="dark" @toggle="checkPause">
                                      <template slot="button-content">
                                        <i class='ft-plus'></i>
                                      </template>
                                      <b-dropdown-item v-on:click='openPaymentModal()'>
                                        <i class="ft-credit-card"></i> Demander un paiement
                                      </b-dropdown-item>
                                      <b-dropdown-item v-on:click='askAuthentication()'>
                                        <i class="ft-user-check"></i> Demander une authentification
                                      </b-dropdown-item>
                                      <b-dropdown-item v-on:click='openProductsModal()'>
                                        <i class="ft-file"></i> Envoyer produit(s)
                                      </b-dropdown-item>
                                      <b-dropdown-item v-on:click='openAddressModal()'>
                                        <i class="ft-link"></i> Envoyer une adresse
                                      </b-dropdown-item>
                                      <b-dropdown-item v-if="CurrentRoom.status == 'late' || CurrentRoom.status == 'running'" v-b-modal.modal-transfer><i class="ft-corner-up-right"></i> Transférer la discussion</b-dropdown-item>
                                      <b-dropdown-item v-if="CurrentRoom.status == 'late' || CurrentRoom.status == 'running'" v-b-modal.modal-block><i class="ft-alert-octagon"></i> Bloquer le visiteur</b-dropdown-item>
                                      <b-dropdown-item v-if="CurrentRoom.status == 'late' || CurrentRoom.status == 'running'" v-b-modal.modal-close><i class="ft-x-square"></i> Fermer la discussion</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <div class="btn-group dropup btn-plus mb-1 align-top">
                                  <label href="#" class="btn btn-dark d-inline-block" for="fileUpload"><i class="ft-file-plus"></i></label>
                                  <input v-on:change="submitFiles()" type='file' id="fileUpload" ref="fileUpload" style="opacity: 0; z-index: -1; position: absolute;" name="file" />
                                </div>
                                <button type="button" class="btn btn-dark align-top send-btn" v-on:click="sendMessage">
                                  <svg width="17" height="17" viewBox="0 0 24 24" fill="#fff">
                                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                                    <path d="M0 0h24v24H0z" fill="none"/>
                                  </svg>
                                </button>
                            </fieldset>
                          </div>
                        </form>
                    </section>
                  </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-12 d-md-none d-xl-block">
            <div class="row">
                <div class="col-xl-6 col-12" v-if="CurrentRoomID">
                  <div class="card my-1">
                      <div class="card-content">
                        <div class="card-body">
                            <h4 class="text-info">
                              <strong>Informations du visiteur</strong>
                            </h4>
                            <ul class="list-group list-group-flush mt-2">
                              <li class="list-unstyled">
                                  <h6>
                                    <strong>Informations générales</strong>
                                  </h6>
                                  <small>
                                  <strong>Nom</strong> {{CurrentRoom.infos.name}}</small>
                                  <br>
                                  <small>
                                  <strong>Langue</strong> {{CurrentRoom.infos.language}}</small>
                                  <br>
                                  <small>
                                  <strong>Appareil</strong> {{CurrentRoom.infos.device}}</small>
                                  <br>
                                  <small>
                                  <strong>Navigateur</strong> {{CurrentRoom.infos.browser}}</small>
                              </li>
                              <hr>
                              <li class="list-unstyled">
                                  <h6>
                                    <strong>Parcours client</strong>
                                  </h6>
                                  <small>
                                  <strong>Actif depuis</strong> {{CurrentRoom.infos.active_since | formatLongDatetime}}</small>
                                  <br>
                                  <small>
                                  <strong>Source</strong> {{CurrentRoom.infos.origin}}</small>
                                  <br>
                                  <small>
                                  <strong>Compétence</strong> {{CurrentRoom.infos.skill}}</small>
                              </li>
                              <hr>
                              <li class="list-unstyled">
                                  <h6>
                                    <strong>Fiche Client</strong>
                                  </h6>
                                  <small>
                                  <strong>Info client</strong> {{CurrentRoom.infos.extra}}</small>
                                  <br>
                                  <small>
                                  <strong>Téléphone</strong> {{CurrentRoom.infos.phone_number}}</small>
                                  <br />
                                  <button v-on:click='openCrmModal()' class="btn btn-info">Recherche client</button>
                              </li>
                              <hr>
                              <li class="list-unstyled">
                                  <h6>
                                    <strong>Satisfaction client</strong>
                                  </h6>
                                  <h3>
                                    <strong>{{CurrentRoom.infos.satisfaction == -1 ? '' : CurrentRoom.infos.satisfaction + '/5'}}</strong>
                                  </h3>
                              </li>
                            </ul>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="col-xl-6 col-12">
                  <div class="card my-1" v-if="CurrentRoomID">
                      <div class="card-content">
                        <div class="card-body">
                            <h4 class="text-info">
                              <strong>Note</strong>
                            </h4>
                            <ul class="list-group list-group-flush mt-2">
                              <li class="list-unstyled">
                                  <small class="d-inline">
                                    <strong class="text-info">Objet&nbsp;&nbsp;</strong>
                                    <input type="text" :value="Note.subject" @input="updateSubject" class="subject-note" placeholder="Objet à éditer">
                                  </small>
                                  <br>
                                  <div>
                                    <textarea :value="Note.content" @input="updateContent" class="content-note" placeholder="Contenu à éditer."></textarea>
                                  </div>
                                  <button type="button" class="btn  round mr-1 mb-1 mt-1 btn-info btn-sm" v-on:click="sendNote">Valider</button>
                              </li>
                            </ul>
                            <small class="float-sm-right text-right mb-2">
                            <a href="#" class="card-link" v-on:click="getNotes()">Notes antérieures</a>
                            </small>
                        </div>
                      </div>
                  </div>
                  <div class="card my-1 history-block" v-if="chatHistory.room">
                    <div class="card-content">
                      <div class="card-body">
                          <h4 class="text-info">
                            <strong>Historique</strong>
                          </h4>
                          <ul class="list-group list-group-flush mt-2">
                            <li class="list-unstyled" v-for="(history, index) in chatHistory.data" :key="index + 'history'">
                              <a href="#" v-on:click="getHistoryMessages(history)">
                                <small>{{history.date | formatLongDatetime}}</small>
                              </a>
                            </li>
                          </ul>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-transfer" ref="modal-transfer" size="lg" class="html-header-footer">
      <div slot="modal-footer">
       </div>
      <div slot="modal-header">
       </div>
        <div class="modal-content p-3 text-center">
          <h3>
            <strong>Transférer la discussion</strong>
          </h3>
          <p>Sélectionnez la compétence vers laquelle vous souhaitez transférer la discussion.</p>
          <div class="row my-2">
            <div v-for="(skill, index) in AllSkills" :key="index + 'skill'" v-bind:class="{'col-md-4 active' : skill.uuid == CurrentSkill , 'col-md-4' : skill.uuid != CurrentSkill}">
              <a class="card text-white bg-info text-center w-100" v-on:click="setSkillForTransfer(skill.uuid)">
                <div class="card-content">
                  <div class="card-body">
                    <h4 class="card-title text-white">{{skill.label}}</h4>
                    <small class="text-muted">Temps d'attente estimé</small>
                    <p class="card-text">{{skill.waiting | formatTime}}</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-outline-dark round mr-1" v-on:click="hideModal('modal-transfer')">Annuler</button>
            <button type="button" class="btn btn-info round" :disabled='!CurrentSkill' v-on:click="transferRoom()">Valider</button>
          </div>
        </div>
    </b-modal>
    <b-modal id="modal-block" ref="modal-block" class="html-header-footer">
      <div slot="modal-footer">
       </div>
      <div slot="modal-header">
      </div>
      <div class="modal-content p-3 text-center">
        <h3>
          <strong>Bloquer ce visiteur</strong>
        </h3>
        <p>Souhaitez-vous vraiment bloquer ce visiteur ?</p>
        <div class="text-center">
          <button type="button" class="btn btn-outline-dark round mr-1" v-on:click="hideModal('modal-block')">Non</button>
          <button type="button" class="btn btn-info round" v-on:click="blockRoom()">Oui</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-close" ref="modal-close" class="html-header-footer">
      <div slot="modal-footer">
       </div>
      <div slot="modal-header">
      </div>
      <div class="modal-content p-3 text-center">
        <h3>
          <strong>Fermer cette discussion</strong>
        </h3>
        <p>Souhaitez-vous vraiment fermer cette discussion ?</p>
        <div class="text-center">
          <button type="button" class="btn btn-outline-dark round mr-1" v-on:click="hideModal('modal-close')">Non</button>
          <button type="button" class="btn btn-info round" v-on:click="closeRoom()">Oui</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-confirmation" ref="modal-confirmation" class="html-header-footer">
      <div slot="modal-footer">
       </div>
      <div slot="modal-header">
      </div>
      <div class="modal-content p-3 text-center" v-if="transferRoomResponse.result == 'success'">
        <h3>
          <strong>Confirmation du transfert</strong>
        </h3>
        <p>La discussion a bien été transférée à la compétence :
          <strong>{{transfferedSkill}}</strong>
        </p>
        <p>Celle-ci se trouve désormais dans la section "En attente", visible par les agents de la compétence
          sélectionnée.</p>
        <div class="text-center">
          <button type="button" class="btn btn-info round" v-on:click="hideModal('modal-confirmation', 'resetTransferRoomResponse')">Ok</button>
        </div>
      </div>
      <div class="modal-content p-3 text-center" v-if="blockRoomResponse.result == 'success'">
        <h3>
          <strong>Visiteur bloqué</strong>
        </h3>
        <p>Ce visiteur ne pourra plus vous joindre.</p>
        <div class="text-center">
          <button type="button" class="btn btn-info round" v-on:click="hideModal('modal-confirmation', 'resetBlockRoomResponse')">Ok</button>
        </div>
      </div>
      <div class="modal-content p-3 text-center" v-if="closeRoomResponse.result == 'success'">
        <h3>
          <strong>Discussion fermée</strong>
        </h3>
        <div class="text-center">
          <button type="button" class="btn btn-info round" v-on:click="hideModal('modal-confirmation', 'resetCloseRoomResponse')">Ok</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-products" ref="modal-products" class="html-header-footer modal-products" hide-backdrop size="lg" no-enforce-focus draggable no-close-on-backdrop @hide="dragToggle = false">
      <div slot="modal-footer">
       </div>
      <div slot="modal-header">
      </div>
      <div class="pt-2 pl-3 pr-3 pb-1 text-center">
        <button class="close" v-on:click="hideModal('modal-products'); dragToggle = false"><i class="ft-x"></i></button>
        <h3>
          <strong>Envoyer une fiche produit</strong>
        </h3>
        <p>Sélectionnez et faites glisser les produits dans la fenêtre de discussion</p>
        <draggable class="my-1 text-left modal-scroll" :options="{group:'products'}" v-model="productItems">
          <div class="media align-items-center" v-for="(product, index) in productItems" :key="index + 'product'">
            <div class="media-left">
              <div class="img-after">
                <img v-bind:src="product.img" alt="..." class="img-thumbnail">
              </div>
            </div>
            <div class="media-body">
              <b>{{product.label}}</b><br>
              {{product.desc}}
            </div>
          </div>
        </draggable>
        <div class="text-center">
          <button type="button" class="btn btn-info round" v-on:click="sendProducts()">Ok</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-address" ref="modal-address" class="modal-address html-header-footer" hide-backdrop size="md" no-enforce-focus draggable no-close-on-backdrop @hide="removePlaces">
        <div slot="modal-footer">
        </div>
        <div slot="modal-header">
        </div>
        <div class="p-3 text-center">
          <button class="close" v-on:click="hideModal('modal-address'); dragToggle = false"><i class="ft-x"></i></button>
          <h3 class="text-center">
            <strong>Envoyer une adresse</strong>
          </h3>
          <div class="my-1">
            <fieldset class="form-group position-relative">
              <gmap-autocomplete id="google-maps-input" class="form-control form-control-xl input-xl" placeholder="Rechercher une adresse ..." selectFirstOnEnter v-on:place_changed="addAddress">
              </gmap-autocomplete>
              <div class="form-control-position">
                <i class="ft-search font-medium-4"></i>
              </div>
            </fieldset>
          </div>
          <div class="my-1 text-left modal-scroll">
            <div class="media align-items-center mb-2" v-for="(place, index) in places" :key="index + 'address'">
              <div class="media-left">
                <div class="img-after">
                  <GmapMap
                    :center="{lat: place.location.position.lat, lng: place.location.position.lng}"
                    :zoom="12"
                    style="width:150px;  height: 150px;"
                  >
                    <GmapMarker
                      :key="index"
                      :position="google && new google.maps.LatLng(place.location.position.lat, place.location.position.lng)"
                    />
                  </GmapMap>
                </div>
              </div>
              <div class="media-body address-block">
                <p class="address-name">{{place.location.label}}</p>
                <button class="btn btn-danger round btn-min-width mr-1 mb-1" v-on:click="removeLocation(index)"><i class="ft-x-circle"></i><span>Remove</span></button>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-outline-dark  round mr-1" v-on:click="hideModal('modal-address')">Annuler</button>
            <button type="button" class="btn btn-info  round" data-dismiss="modal" v-on:click="sendAddress()">Envoyer</button>
          </div>
        </div>
    </b-modal>
    <b-modal id="modal-apple" ref="modal-apple" class="html-header-footer">
        <div slot="modal-footer">
        </div>
        <div slot="modal-header">
        </div>
        <div class="modal-content p-3 text-center">
          <h3>
            <strong>Appel Zen</strong>
          </h3>
          <h3 class="text-info">
            <strong>Rappel immédiat ou planifié</strong>
          </h3>
          <p>Sélectionnez une compétence à laquelle le rappel est destiné :</p>
          <div class="form-group">
            <select class="form-control" id="exampleFormControlSelect1" v-model="zencallSkill">
              <option value="" selected>Merci de choisir une compétence AppelZen</option>
              <option v-for="(skill, index) in CurrentZencalls" :key="index + 'skill-appel'" :value="skill.uuid">{{skill.label}}</option>
            </select>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-outline-dark  round mr-1" v-on:click="hideModal('modal-apple')">Annuler</button>
            <button type="button" class="btn btn-info  round" v-on:click="sendZencall()">Valider</button>
          </div>
        </div>
    </b-modal>
    <b-modal id="modal-crm" ref="modal-crm" class="html-header-footer">
        <div slot="modal-footer">
        </div>
        <div slot="modal-header">
        </div>
        <div class="modal-content p-3 text-center">
          <h3>
            <strong>CRM</strong>
          </h3>
          <h3 class="text-info">
            <strong>Recherche d'utilisateurs</strong>
          </h3>
          <div class="form-group">
            <input type="text" class="form-control" id="" v-model="crm.search">
          </div>
          <div class="my-1 text-left modal-scroll">
            <p>Résultats pour {{ crm.search }}</p>
            <button class="btn btn-outline-light btn-block"
                    v-if="crmResults" v-for="result in crmResults"
                    v-bind:key="result.id"
                    v-on:click="saveCrmInfos(result.id)">
              <b>{{ result.name }}</b>
              <span v-if="result.org_name">&nbsp;({{ result.org_name }})</span>
              <ul>
                <li v-if="result.phone">Téléphone: {{ result.phone }}</li>
                <li v-if="result.email">Email: {{ result.email }}</li>
              </ul>
            </button>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-outline-dark  round mr-1"
                    v-on:click="hideModal('modal-crm')">Fermer</button>
          </div>
        </div>
    </b-modal>
    <b-modal id="modal-payment" ref="modal-payment" class="html-header-footer">
      <div slot="modal-footer">
      </div>
      <div slot="modal-header">
      </div>
      <div class="modal-content p-3 text-center">
        <h3>
          <strong>Demander un paiement</strong>
        </h3>
        <div class="row">
          <div class="col-md-12">
            <input type="text" class="form-control" v-model="payment.title">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Libellé</th>
                  <th>Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in payment.items" v-bind:key="index">
                  <td>
                    <input type="text" class="form-control"
                           v-model="item.label">
                  </td>
                  <td>
                    <input type="text" class="form-control"
                           v-model="item.amount">
                    <!-- v-money="money"-->
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-right">
                    <button class="btn btn-dark round mr-1"
                            v-on:click="addPaymentItem()">
                      Ajouter une ligne
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <input type="text" class="form-control"
                   v-model="payment.total.label">
          </div>
          <div class="col-md-6">
            <input type="text" class="form-control"
                   v-model.lazy="payment.total.amount">
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center mt-1">
            <button type="button" class="btn btn-outline round mr-1"
                    v-on:click="hideModal('modal-payment');payment=initPayment();">
              Annuler
            </button>
            <button type="button" class="btn btn-outline-dark  round mr-1"
                    v-on:click="sendPayment()">
              Valider
            </button>

          </div>
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>
import Vue from 'vue'
import VueCurrencyFilter from 'vue-currency-filter'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Picker } from 'emoji-mart-vue'
import { VMoney } from 'v-money'
import { gmapApi } from 'vue2-google-maps'
import draggable from 'vuedraggable'
import VueResource from 'vue-resource'
import config from '../config/index'
import Loader from '../views/Loader'

Vue.use(VueResource)
Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'end',
  symbolSpacing: true
})

export default {
  components: {
    VuePerfectScrollbar,
    draggable,
    Picker,
    'loader': Loader
  },
  data: function () {
    return {
      dragToggle: false,
      transfferedSkill: '',
      historyShown: false,
      currentHistory: '',
      productItems: [],
      itemsForPayment: [],
      draggedItems: [],
      places: [],
      currentPlace: null,
      showEmojiPicker: false,
      zencallSkill: '',
      crm: {
        search: ''
      },
      payment: this.initPayment(),
      money: {
        decimal: ',',
        thousands: ' ',
        prefix: '',
        suffix: ' €',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  computed: {
    google: gmapApi,
    userSettings () {
      return this.$store.getters.getOwnSettings
    },
    blockRoomResponse () {
      return this.$store.getters.getBlockRoomResponse
    },
    closeRoomResponse () {
      return this.$store.getters.getCloseRoomResponse
    },
    transferRoomResponse () {
      return this.$store.getters.getTransferRoomResponse
    },
    AllSkills () {
      return this.$store.getters.getSkills
    },
    CurrentRoom () {
      return this.$store.getters.getCurrentRoom
    },
    CurrentRoomID () {
      return this.$store.getters.getCurrentRoomUuid
    },
    AllRooms () {
      return this.$store.getters.getAllRooms
    },
    CurrentZencalls () {
      return this.$store.getters.getZencalls
    },
    Messages () {
      return this.$store.getters.getMessages
    },
    CurrentMessage () {
      return this.$store.getters.getSendMessageRequestObject
    },
    CurrentSkill () {
      return this.$store.getters.getCurrentTransferSkill
    },
    chatHistory () {
      return this.$store.getters.getHistoryResponse
    },
    AllProducts () {
      return this.$store.getters.getProducts
    },
    Note () {
      return this.$store.getters.getSendNoteRequest
    },
    CurrentTimer () {
      return this.$store.getters.getMainTime
    },
    PendingRequest () {
      return this.$store.getters.getPendingRequests
    },
    crmResults () {
      return this.$store.getters.getCrmResults
    }
  },
  directives: {
    money: VMoney
  },
  methods: {
    askAuthentication () {
      let data = {
        uuid: this.uuidv4()
      }
      this.$socket.askAuthentication(data)
    },
    initPayment () {
      let items = []
      if (this.itemsForPayment !== undefined && this.itemsForPayment.length > 0) {
        this.itemsForPayment.forEach((item) => {
          items.push({
            label: item.label,
            amount: 0
          })
        })
      }
      return {
        title: '',
        items: items,
        total: {
          label: 'Total',
          amount: 0
        }
      }
    },
    initPaymentItem () {
      return {
        label: '',
        amount: 0
      }
    },
    isObject (o) {
      return typeof o === 'object'
    },
    toggleEmojiPicker () {
      this.showEmojiPicker = !this.showEmojiPicker
    },
    addPaymentItem () {
      this.payment.items.push(this.initPaymentItem())
    },
    updateSubject (e) {
      this.$store.dispatch('setSubjectForSendNote', e.target.value)
    },
    updateContent (e) {
      this.$store.dispatch('setContentForSendNote', e.target.value)
    },
    removePlaces () {
      this.places = []
    },
    sendNote () {
      this.$socket.sendNote()
    },
    addAddress (place) {
      let el = document.getElementById('google-maps-input')
      let placeHelper = {}
      if (place.geometry == null) {
        return
      }
      placeHelper.kind = 'location'
      placeHelper.location = {}
      placeHelper.location.position = place.geometry.location
      placeHelper.location.label = place.formatted_address

      placeHelper = JSON.stringify(placeHelper)
      this.places.push(JSON.parse(placeHelper))
      el.value = ''
    },
    checkPause (e) {
      if (this.userSettings.paused) {
        this.$store.dispatch('writeErrorResponse', {
          cmd: 'on_pause', error: 'agent_on_pause'
        })
      }
    },
    sendProducts () {
      this.itemsForPayment = this.draggedItems
      this.$socket.sendProducts(this.draggedItems)
      this.$refs['modal-products'].hide()
      this.dragToggle = false
    },
    hideModal (modal, actionToDispatch) {
      this.$refs[modal].hide()
      if (typeof actionToDispatch !== 'undefined') {
        this.$store.dispatch(String(actionToDispatch))
      }
    },
    getTotalLength (arr) {
      let sum = 0
      for (let i in arr) {
        sum += arr[i].length
      }
      return sum
    },
    getSkillName (skillID) {
      return this.AllSkills.filter(item => item.uuid === skillID).map(item => item.label)[0]
    },
    transferRoom () {
      this.transfferedSkill = this.getSkillName(this.CurrentSkill)
      this.$socket.transferRoom()
    },
    blockRoom () {
      this.$socket.blockRoom()
    },
    closeRoom () {
      this.$socket.closeRoom()
    },
    joinRoom (uuid) {
      this.historyShown = false
      this.$socket.joinRoom(uuid)
    },
    getZencalls () {
      this.$refs['modal-apple'].show()
      this.$socket.getZencalls()
    },
    sendZencall () {
      if (this.zencallSkill) {
        this.$socket.launchZencall(this.zencallSkill)
        this.$refs['modal-apple'].hide()
      }
    },
    setCurrentRoom (uuid) {
      this.$store.dispatch('setCurrentRoom', uuid)
      this.$socket.getMessages()
      this.$socket.getHistory()
      this.hideModal('modal-products')
      this.hideModal('modal-address')
      this.dragToggle = false
      this.historyShown = false
      this.zencallPhone = ''
    },
    setCurrentMessage (e) {
      this.$store.dispatch('setContentForSendMessage', e.target.value)
    },
    sendMessage (e) {
      e.target.value = ''
      e.preventDefault()
      this.$socket.sendMessage()
    },
    setSkillForTransfer (uuid) {
      this.$store.dispatch('setSKillForTransferRequest', uuid)
    },
    getHistoryMessages (event) {
      this.hideModal('modal-products')
      this.hideModal('modal-address')
      this.historyShown = true
      this.$socket.getMessagesFromHistory(event.uuid)
      this.currentHistory = event.date
    },
    getDefaultMessages () {
      this.historyShown = false
      this.$socket.getMessages()
    },
    openCrmModal () {
      this.crm.search = ''
      this.$refs['modal-crm'].show()
    },
    openPaymentModal () {
      this.payment = this.initPayment()
      this.$refs['modal-payment'].show()
    },
    openProductsModal () {
      this.itemsForPayment = []
      this.$socket.getProducts()
      this.$refs['modal-products'].show()
      this.dragToggle = true
    },
    openAddressModal () {
      this.$refs['modal-address'].show()
    },
    sendAddress () {
      this.$socket.sendLocations(this.places)
      this.$refs['modal-address'].hide()
    },
    removeLocation (placeIndex) {
      this.places.splice(placeIndex, 1)
    },
    getNotes () {
      this.$socket.getNotes()
    },
    documentClick (e) {
      let el = document.getElementById('emoji-trigger')
      let elPicker = document.getElementById('emoji-picker')
      let target = e.target
      if ((el !== target) && !el.contains(target) && !elPicker.contains(target)) {
        this.showEmojiPicker = false
      }
    },
    addEmoji (emoji) {
      document.getElementById('chat-input').value += emoji.native
      this.$store.dispatch('setContentForSendMessage',
        document.getElementById('chat-input').value)
    },
    updateTime (value) {
      let currentTime = +new Date(this.CurrentTimer)
      let diff = currentTime - value * 1000
      return new Date(diff).toLocaleTimeString('en-GB', {
        timeZone: 'UTC'
      })
    },
    getClosedRoomTime (room) {
      let diff = room.last_closed * 1000 - room.last_running * 1000
      return new Date(diff).toLocaleTimeString('en-GB', {
        timeZone: 'UTC'
      })
    },
    submitFiles () {
      let formData = new FormData()

      let token = localStorage.getItem('token')

      let uploadFile = this.$refs.fileUpload.files[0]

      formData.append('file', uploadFile)

      token = token.substring(1, token.length)

      let vm = this

      this.$http.post(`${config.serverHttp}/agents/upload/`,
        formData,
        {
          headers: {
            'Authorization': 'Token ' + token,
            'Content-Type': 'multipart/form-data;'
          }
        }
      ).then(function (response) {
        vm.$socket.sendFiles({
          url: response.data.file,
          txt: uploadFile.name,
          mimetype: uploadFile.type
        })
      }).catch(function (error) {
        vm.$store.dispatch('writeErrorResponse', {
          cmd: 'upload_error', error: error.body.error })
      })
    },
    saveCrmInfos (resultId) {
      let found = false
      let data = {
        'cmd': 'set_guest_infos',
        'room': this.CurrentRoomID,
        'extra': '',
        'phone_number': ''

      }
      this.crmResults.forEach((item) => {
        if (!found && item.id === resultId) {
          data['extra'] = item.name
          if (item.org_name) {
            data['extra'] += '(' + item.org_name + ')'
          }
          data['phone_number'] = item.phone
        }
      })
      this.$socket.send(data)
      this.CurrentRoom.infos.phone_number = data['phone_number']
      this.CurrentRoom.infos.extra = data['extra']
      this.hideModal('modal-crm')
    },
    sendPayment () {
      this.payment.uuid = this.uuidv4()
      this.$socket.sendPayment(this.payment)
      this.$refs['modal-payment'].hide()
      this.payment = this.initPayment()
    },
    uuidv4: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g, function (c) {
          var r = Math.random() * 16 | 0
          var v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
    }
  },
  watch: {
    AllProducts: function (newResponse, oldResponse) {
      this.productItems = newResponse
      this.draggedItems = []
    },
    transferRoomResponse: function (newResponse, oldResponse) {
      if (newResponse.result !== '') {
        this.$refs['modal-confirmation'].show()
      }
    },
    closeRoomResponse: function (newResponse, oldResponse) {
      if (newResponse.result !== '') {
        this.$refs['modal-confirmation'].show()
      }
    },
    blockRoomResponse: function (newResponse, oldResponse) {
      if (newResponse.result !== '') {
        this.$refs['modal-confirmation'].show()
      }
    },
    Messages: function (newResponse, oldResponse) {
      if (!(this.CurrentRoom.status === 'waiting' || this.CurrentRoom.status === 'transferred' || this.historyShown)) {
        this.$nextTick(function () {
          var objDiv = document.getElementById('chat-app-window')
          objDiv.scrollTop = objDiv.scrollHeight
        })
      } else {
        this.$nextTick(function () {
          var objDiv = document.getElementById('chat-app-window')
          objDiv.scrollBottom = objDiv.scrollHeight
        })
      }
    },
    'crm.search' (newValue, oldValue) {
      let data = {
        'cmd': 'crm_research',
        'term': newValue
      }
      this.$socket.send(data)
    },
    'payment.items': {
      handler (newValue, oldValue) {
        let total = 0
        newValue.forEach((item) => {
          let amount
          try {
            amount = item.amount.replace(',', '.')
          } catch (error) {
            amount = item.amount
          }
          total += parseFloat(amount, 10)
        })
        total = Math.round(total * 100) / 100
        this.payment.total.amount = total.toString()
      },
      deep: true
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="sass">
    @import '../app-assets/css/pages/chat-application.css';
</style>
